
export const selectPlayer = (state) => state.player;

export const selectAction = (state) => selectPlayer(state).action ? selectPlayer(state).action : {};
export const selectState = (state) => selectPlayer(state) ? selectPlayer(state) : {};

export const selectHasPlayed = (state) => selectAction(state).key && (selectAction(state).key == selectState(state).key);
export const selectShouldRefresh = (state) => !selectState(state).key || (selectAction(state).key == selectState(state).key) || selectState(state).state=="Waiting";
export const selectIsInGame = (state) => (selectPlayer(state).currentgame || false);
